export default __webpack_public_path__ + "static/media/right-green-arrow.fe83e9bb.svg";